import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./NewPageContentToast.styles.css";
import { useTranslation } from "react-i18next";
import Icons from "shared/icons";

function NewPageContentToast() {
  const { t } = useTranslation("Shared");
  return (
    <span className="d-flex flex-row align-items-center new-page-content__tooltip">
      <FontAwesomeIcon className="d-block me-3" icon={Icons.circleInfo} />
      {t("new_version_is_available")}
    </span>
  );
}

export default NewPageContentToast;
